import React, { useContext, useCallback, useState, FC } from 'react';
import { connect } from "react-redux"
import { Form, Button, Message } from 'semantic-ui-react';
import { toast } from 'react-toastify';

import API, { ResponseManagement, ErrorManagement } from '../../../API';
import Utility from '../../../Utility';
import ModalTransition from '../../ModalTransition/ModalTransition';
import GlobalContext from '../../../contexts/GlobalContext';
import { RootDispatch, RootState } from '../../../store';
import BookingCancellationConditionAccordion from '../BookingAccordion/BookingCancellationConditionAccordion';

const mapProps = (state: RootState) => ({
  bookings: state.booking.bookings,
  bookingFolder: state.booking.bookingFolder,
  bookingCancel: state.booking.bookingCancel,
  selectedBooking: state.booking.selectedBooking, // si lui a pas les bon data
  cancelBookingModal: state.modal.cancelBookingModal,
  cancellationConditions: state.rateplan.cancellationConditions
})

const mapDispatch = (dispatch: RootDispatch) => ({
  handleModal: dispatch.modal.handleModal,
  updateBookingByIndex: dispatch.booking.updateBookingByIndex,
})

type Props = {
  booking?: any
  theIndex?: number
} & ReturnType<typeof mapProps> & ReturnType<typeof mapDispatch>

type languageItem = {
  country?: string
  id?: number
  iso?: string
  name?: string
  originalName?: string
}

const ModalConfirmCancelBooking: FC<Props> = ({
  bookings,
  bookingCancel,
  selectedBooking,
  handleModal,
  cancelBookingModal,
  bookingFolder,
  cancellationConditions,
  updateBookingByIndex,
}) => {
    const [globalContext] = useContext(GlobalContext) as any;
    const [textModifState, setTextModifState] = useState<string>('');
    const [loading, setLoading] = useState(false)
    const [showAddNewBooking, setShowAddNewBooking] = useState(false)

    let linkBe = ``;
    let bookingEngineLinkProps = {};
    if( showAddNewBooking ){
      let cityBook = "";
      let langIso = localStorage.getItem('lang');
      if (langIso === 'EN') {
        langIso = 'UK';
      }

      let filteredObjLang = {} as languageItem;
      if (globalContext?.languages !== undefined) {
        filteredObjLang = globalContext.languages.find(objLang => {
          return objLang.iso === langIso
        });
      }

      let langBe = Object.keys(filteredObjLang).length > 0 ? filteredObjLang.name : langIso;

      if( typeof globalContext.establishmentCollection[bookingFolder.establishmentId] != "undefined"){
        let etabTemp = globalContext.establishmentCollection[bookingFolder.establishmentId]
        // city booking
        cityBook = etabTemp?.city+" - "+etabTemp?.zipCode;

        // lien be
        if( etabTemp?.customLinkBe != '' && typeof etabTemp?.customLinkBe !== "undefined" ){
          linkBe = `${etabTemp?.customLinkBe}`;
        }
        else{
          linkBe = Utility.getBookingEngineUrl(etabTemp?.bookingEngineId, langBe);
          bookingEngineLinkProps = Utility.getBookingEngineLinkProps(etabTemp?.bookingEngineId, linkBe);
        }
      }
    }

    const handleTextChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => setTextModifState(e.target.value);

    const handleClose = () => handleModal({cancelBookingModal: false})


    const handleClickConfirmCancelBooking = useCallback(() => {
      //globalContext.establishmentCollection[bookingFolder.establishmentId]?.city
      if (  globalContext.establishmentCollection[bookingFolder.establishmentId]?.cancellationCauseRequire == 'oui'
            && bookings?.[selectedBooking.index]?.status !== 'pending'
            && textModifState.trim() == ''
      ){
      //if ( globalContext.establishment.cancellationCauseRequire == 'oui' && bookings?.[selectedBooking.index]?.status !== 'pending' && textModifState.trim() == '' ){
        toast.error( globalContext.translations.cancellationTextEmpty );
      }
      else {
        setLoading(true)
        const dataToSend = new URLSearchParams();
        dataToSend.set('bookingFolderId', bookingFolder.id.toString());
        dataToSend.set('textModif', textModifState);
        dataToSend.set(`bookingIds[${selectedBooking.id}]`, selectedBooking.id.toString());
        // dataToSend.set("isBookingDRW", bookings?.[selectedBooking.index]?.status === 'pending' ? 'true' : 'false')

        const bookingIndex = bookings.findIndex(
          (booking) => booking.id === selectedBooking.id
        );
        //const booking = { ...bookings[bookingIndex] };

        API.post(Utility.getUrlAjax() + `/cancelBookingAction`, dataToSend)
        .then(response => {
          ResponseManagement(response,
            () => {
              setShowAddNewBooking(true)
              // add proposition add résa
              toast.success(response.data.message)
              updateBookingByIndex({
                bookingIndex,
                booking:{status:'cancel'},
              });
              //window.location.reload();
            },
            () => {
              if ( typeof globalContext.translations[response.data.message] != "undefined" && globalContext.translations[response.data.message] != '' ) {
                toast.error(globalContext.translations[response.data.message]);
              }
              else{
                toast.error(response.data.message);
              }

            }
          );
        })
        .catch(error => {
          ErrorManagement(error, () => {}, globalContext.translations);
        })
        .finally(() => {
          setLoading(false)
          //handleModal({cancelBookingModal: false})
        })
      }

    }, [bookingFolder.id, selectedBooking.id, textModifState])

    /**
     * Retourne le contenu de la modal
     * @returns Object
     */
    const getContent = () => {
      let content = [];
      // content modal annul résa
      if( !showAddNewBooking ){
        if (Number(selectedBooking.id) > 0) {
          if (bookings?.[selectedBooking.index]?.status !== 'pending') {
            if (bookingCancel?.bookings?.[selectedBooking.id]?.isCancellable === true) {
              if (bookingCancel?.bookings?.[selectedBooking.id]?.cancellationAmount !== "0") {
                content.push(
                  <h4 key="annul_future_annul_title">
                    {
                      globalContext.translations.contentModalConfirmCancelBookingSuccessWithPayment.replace('{{cancellationAmount}}', `${bookingCancel.bookings[selectedBooking.id].cancellationAmount} ${bookings[selectedBooking.index].currency}`)
                    }
                  </h4>);
              }
              content.push(
                <div key="annul_future_annul_cond">
                  {cancellationConditions[selectedBooking?.cancellationConditionId] &&
                  <div style={{marginBottom: '1.33em'}}>
                    <BookingCancellationConditionAccordion
                      title={globalContext.translations.watchCancellationConditionLabelTitle}
                      name={cancellationConditions[selectedBooking?.cancellationConditionId].name}
                      description={cancellationConditions[selectedBooking?.cancellationConditionId].description}
                    />
                  </div>
                  }
                  <div>
                    <p>{globalContext.translations.contentModalConfirmCancelBookingMotif}</p>
                    <Form.TextArea
                      onChange={handleTextChange}
                      id="textModif"
                      rows={4}
                      value={textModifState}
                    />
                  </div>
                </div>
              );
            } else {
              content = globalContext.translations.contentModalConfirmCancelBookingError;
            }
          } else {
            content.push(
              <div key="annul_drw">
                <h4>
                  {globalContext.translations.contentModalConfirmCancelBookingSuccess}
                </h4>

                <p>{globalContext.translations.contentModalCancelBookingDRW}</p>
              </div>
            );
          }
        }
      }
      // content modal add new booking
      else{

        content.push(
          <Message positive key="success_message">
            <Message.Header>{ globalContext.translations.successCancelBooking }</Message.Header>
            <p>
              { globalContext.translations.addNewBooking }
            </p>
          </Message>
        );
      }

      return content;
    }

    return (
      (Number(selectedBooking.id) > 0) ?
        <ModalTransition
          size="tiny"
          open={cancelBookingModal}
          handleClose={handleClose}
          header={ !showAddNewBooking ? globalContext.translations.headerModalConfirmCancelBooking : globalContext.translations.headerModalAddNewBooking }
          content={
            <Form>
              {getContent()}
            </Form>
          }
          actions={
            <>
              {!showAddNewBooking ?
                <>
                  <p>{globalContext.translations.contentModalConfirmCancelBookingSuccessConfirme}</p>
                  <div>
                    <Button
                      color="grey"
                      icon="delete"
                      labelPosition="right"
                      disabled={loading}
                      content={Utility.ucFirst(globalContext.translations.back)}
                      onClick={handleClose}
                    />
                    {(Number(selectedBooking.id) > 0 && bookingCancel?.bookings?.[selectedBooking.id]?.isCancellable === true) &&
                    <Button
                      loading={loading}
                      disabled={loading}
                      negative
                      icon="checkmark"
                      labelPosition="right"
                      content={globalContext.translations.validate}
                      onClick={handleClickConfirmCancelBooking}
                    />
                    }
                  </div>
                </>
              : <div>
                  <Button
                    negative
                    icon="delete"
                    labelPosition="right"
                    disabled={loading}
                    content={Utility.ucFirst(globalContext.translations.no)}
                    onClick={handleClose}
                  />
                  {(Number(selectedBooking.id) > 0 && bookingCancel?.bookings?.[selectedBooking.id]?.isCancellable === true) &&
                  <Button
                    as="a" target="_blank" href={linkBe} {...bookingEngineLinkProps}
                    //loading={loading}
                    //disabled={loading}
                    positive
                    icon="checkmark"
                    labelPosition="right"
                    content={globalContext.translations.yes}
                    //onClick={handleClickConfirmCancelBooking}
                  />
                  }
                </div>
               }

            </>
          }
        />
      :
      null
    )
}

export default connect(mapProps, mapDispatch)(ModalConfirmCancelBooking);
